import http from "./http.service";
import themeConfig from "./whitelabel/whitelabel-infos";
import whitelabelService from "./whitelabel/whitelabel.service";

class PlateService {
  private isProductionDomain(): boolean {
    const { host } = window.location;
    const subdomain = host.split('.')[0];

    const themeItem = themeConfig
      .find(item => item.workspace === subdomain);

    return !!themeItem;
  }

  public searchByPlate = async (vehicleIdentifier: string) => {
    const whitelabelCompany = whitelabelService.getWBDataCompany();
    let obj: any = {};

    if (this.isProductionDomain()) {
      obj = {
        api_token: whitelabelCompany.api,
      };
    } else {
      obj = {
        api_token: process.env.REACT_APP_API_TOKEN,
      };
    }


    if (vehicleIdentifier.length === 7) {
      obj.plate = vehicleIdentifier;
    } else if (vehicleIdentifier.length > 7) {
      obj.chassis = vehicleIdentifier;
    }

    return http.post('v1/aggregate', obj);
  }
}
export default new PlateService();
